<template>
  <BaseDialog max-width="800" persistent :value="true">
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="$t('inactive_alert.modal.title')" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              :disabled="isSubmiting"
              @click="reset()"
            />
          </div>
        </template>
        <div class="modal_content">
          <v-progress-linear
            v-if="isSubmiting"
            class="progression"
            indeterminate
          />
          <div class="input_group">
            <div
              class="input_label"
              v-text="$t('inactive_alert.modal.label')"
            />
            <BaseTextField
              v-model="inactivityDaysLimit"
              outlined
              autofocus
              type="number"
              :placeholder="$t('inactive_alert.modal.placeholder')"
              :disabled="isSubmiting"
              :error-messages="valueErrors"
              @change="$v.inactivityDaysLimit.$touch()"
              @blur="$v.inactivityDaysLimit.$touch()"
              @keypress.enter="submit()"
            />
          </div>
        </div>
        <div class="modal_footer">
          <BaseButton
            :disabled="isSubmiting"
            color="grey"
            type="secondary"
            @click="reset()"
          >
            {{ $t("utils.cancel") }}
          </BaseButton>
          <BaseButton
            :disabled="isSubmiting"
            color="primary"
            type="primary"
            @click="submit()"
          >
            {{ $t("utils.validate") }}
          </BaseButton>
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>
<script>
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "WorkflowInactivityDaysLimitModal",
  mixins: [validationMixin],
  props: {
    organizationId: {
      type: [Number, String],
      required: true,
    },
    workflow: {
      type: Object,
      required: true,
    },
  },
  validations: {
    inactivityDaysLimit: {
      required,
      minValue: (value) => value > 0,
    },
  },
  data() {
    return {
      isSubmiting: false,
      inactivityDaysLimit: null,
    };
  },
  computed: {
    valueErrors() {
      const errors = [];
      if (!this.$v.inactivityDaysLimit.$dirty) return errors;
      if (!this.$v.inactivityDaysLimit.required) {
        errors.push(this.$t("inactive_alert.errors.required"));
      }
      if (!this.$v.inactivityDaysLimit.minValue) {
        errors.push(this.$t("inactive_alert.errors.invalid"));
      }
      return errors;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.inactivityDaysLimit = this.workflow.inactivityDaysLimit || null;
    },
    reset() {
      if (this.isSubmiting) return;
      this.inactivityDaysLimit = null;
      this.$emit("close");
    },
    async submit() {
      this.$v.inactivityDaysLimit.$touch();
      if (this.$v.inactivityDaysLimit.$invalid) return;
      this.isSubmiting = true;
      try {
        await WorkflowAPI.patchOrganizationWorkflow(
          this.organizationId,
          this.workflow.id,
          {
            inactivity_days_limit: this.inactivityDaysLimit,
          }
        );
        this.$emit("workflowUpdated", {
          ...this.workflow,
          inactivityDaysLimit: this.inactivityDaysLimit,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("inactive_alert.messages.update_success"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("inactive_alert.messages.update_error"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  padding-top: 24px;
  position: relative;
  .progression {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .input_group {
    .input_label {
      color: #353542;
      font-family: Inter;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;

      margin-bottom: 10px;
    }
  }
}
.modal_footer {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding: 8px 0;
  gap: 16px;
}
</style>
